import React, { useState } from "react";
import CommonModal from "@/components/common/modal"; // Import the new CommonModal
import AIConfigContent from "./AIConfigModal/AIConfigContent"; // Import the new AIConfigContent
import { FormattedMessage, injectIntl } from "react-intl";

const AIConfigModal = ({
    agentId,
    visible,
    onClose,
    onSave,
    initialData = {},
    intl,
}) => {
    const [title, setTitle] = useState("");
    return (
        <CommonModal
            modalStyle={{ top: 20 }}
            visible={visible}
            onClose={onClose}
            title={title ? `${title}-${intl.formatMessage({ id: "gui.agentManage.agent", defaultMessage: "Agent" })}` : "-"} // Title for the common modal
        >
            {agentId && (
                <AIConfigContent
                    setTitle={setTitle}
                    agentId={agentId}
                    onSave={onSave}
                    initialData={initialData}
                />
            )}
        </CommonModal>
    );
};

export default injectIntl(AIConfigModal);